<div appFilterColumnsAutoFocus class="flex-column justify-content-center px-5 pb-5">
    <app-drivers-table></app-drivers-table>
</div>